import { PROJCOMP } from "../_constants/actionConstants";

const projCompInitialState = {
  fetching: false,
  openBidItemDetails: {}, // Normalized by bidItemId
  openLocationDetails: {}, // Normalized by locationId
  miscSessionData: {}, // Normalized by tabId
};

export const reducer = (state = projCompInitialState, action) => {
  switch (action.type) {
    case PROJCOMP.FETCH_LOCATION_DETAILS_FULFILLED: {
      const { locationId, payload } = action;
      return {
        ...state,
        fetching: false,
        openLocationDetails: { ...state.openLocationDetails, [locationId]: payload },
      };
    }

    default:
      return state;
  }
};
